import { createAction } from 'redux-act';

export const openPointsClubModal = createAction('ui/OPEN_POINTS_CLUB_MODAL');
export const setIsPointsPay = createAction('ui/SET_IS_POINTS_PAY');
export const setMapHoveredPropertyId = createAction('ui/SET_MAP_HOVERED_PROPERTY_ID');
export const setMapActivePropertyId = createAction('ui/SET_MAP_ACTIVE_PROPERTY_ID');
export const setDateChangeMessaging = createAction('ui/SET_DATE_CHANGE_MESSAGING');
export const clearDateChangeMessaging = createAction('ui/CLEAR_DATE_CHANGE_MESSAGING');
export const fetchAppVersion = createAction('ui/FETCH_APP_VERSION');
export const setAppVersion = createAction('ui/SET_APP_VERSION');
export const setPropertyFiltersModalVisible = createAction('ui/SET_PROPERTY_FILTERS_MODAL_VISIBLE');
